import React from 'react'
import { Grid, Typography, Button, TextField, Link } from '@mui/material'
import colors from '../../../../../colors'
import ButtonGroup from '../../../../../general/ButtonGroup'
import { determineUtilityRequest } from '../../DetermineUtilityRequest'
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../../../../features/userInfo/userInfoSlice'
import { selectUtilityState, setSentFrom } from '../../../../../../features/utilities/utilitySlice'
import { selectMyContractsState, setShouldFillFields } from '../../../../../../features/myContracts/myContractsSlice'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom'
import { texts } from '../../../../../general/texts'

export const Firstcom = (props) => {

    const utilitySliceState = useSelector(selectUtilityState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const navigate = useNavigate()

    const searchMethods = [
        { display: texts["title-phone-number-short"], value: '1' },
        { display: texts["id-number"], value: '2' }
    ]

    const dispatch = useDispatch()
    const userInfo = useSelector(selectUserInfo)

    const [state, setState] = React.useState({
        utilityName: props.utilityName,
        token: props.globalDataSliceState.token,
        selectedSearchMethod: searchMethods[0].value,
        fullName: '',
        phoneNr: '',
        invoiceID: ''
    })

    const handleTextFieldChange = (prop) => (e) => {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }


    const handleButtonClick = (sentFrom) => {
        dispatch(utilityRequest)
        dispatch(setSentFrom(sentFrom))
    }

    const utilityRequest = determineUtilityRequest(state)

    React.useEffect(() => {
        if (myContractsSliceState.shouldFillFields) {
            setState({
                ...state,
                fullName: props.selectedContractInfo.contract,
                phoneNr: props.selectedContractInfo.description
            })
            dispatch(setShouldFillFields(false))
        }
    }, [myContractsSliceState.shouldFillFields])

    const useStyles = makeStyles({
        mainGrid: {
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName: {
            color: props.utilityInfo.Color,
            fontSize: '1.5rem',
            fontFamily: 'GerberaBold',
            paddingTop: '3%',
            paddingLeft: '2%'
        },
        headerBox: {
            backgroundColor: colors.cyan,
            borderRadius: '100%',
            width: '70px',
            height: '70px'
        },
        fieldTitle: {
            color: colors.darkBlue,
            fontSize: '1.2rem',
            fontFamily: 'GerberaBold',
            textAlign: 'left'
        },
        button: {
            width: '100%',
            color: colors.white,
            fontSize: '1rem',
            textTransform: 'none',
            background: colors.gradientOrange,
            fontFamily: 'GerberaBold'
        },
        buttonGrid: {
            marginTop: 150,
            paddingBottom: 5
        },
        image: {
            width: '50%',
        },
        textField: {
            width: '100%'
        }
    })

    const classes = useStyles()


    return (
        <Grid container item className={classes.mainGrid} rowSpacing={3}>
            <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={() => { navigate(-1) }}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
            <Grid container item md={12} xs={12}>
                <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0]?.imagePath} className={classes.image} /></Grid>
                <Typography className={classes.utilityName}>{props.utilityInfo.PublicName}</Typography>
            </Grid>
            <Grid container item md={12} xs={12} >
                <Typography className={classes.fieldTitle}>{texts["prompt-fill-fields"]}:</Typography>
            </Grid>
                <Grid container item rowSpacing={1} >
                    <Grid item md={12} xs={12} >
                        <Typography className={classes.fieldTitle} style={{ fontSize: '16px', fontFamily: 'GerberaMedium' }}>{texts["placeholder-name"]}</Typography>
                    </Grid>
                    <Grid item md={12} xs={12} >
                        <TextField onChange={handleTextFieldChange('fullName')} value={state.fullName} color='warning' size='small' className={classes.textField} />
                    </Grid>
                    <Grid item md={12} xs={12} >
                        <Typography className={classes.fieldTitle} style={{ fontSize: '16px', fontFamily: 'GerberaMedium' }}>{texts["title-phone-number-short"]}</Typography>
                    </Grid>
                    <Grid item md={12} xs={12} >
                        <TextField onChange={handleTextFieldChange('phoneNr')} value={state.phoneNr} color='warning' size='small' className={classes.textField} />
                    </Grid>
                    <Grid item md={12} xs={12} className={classes.buttonGrid}  >
                        <Button disabled={utilitySliceState.isLoading ? true : false} onClick={() => { handleButtonClick('contractList') }} className={classes.button}  >{texts["title-search"]}</Button>
                    </Grid>
                </Grid>

        </Grid>
    )
}
export default Firstcom
